__turbopack_context__.v({
  "className": "sfprodisplaybold_def048f2-module__R_2BCW__className",
  "variable": "sfprodisplaybold_def048f2-module__R_2BCW__variable",
});
